module.exports = __webpack_public_path__ + "static/img/2.90a681b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/2.png
// module id = CtMo
// module chunks = 1